import { render, staticRenderFns } from "./ShowPage.vue?vue&type=template&id=7c184a3e&scoped=true&lang=pug&"
import script from "./ShowPage.vue?vue&type=script&lang=js&"
export * from "./ShowPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowPage.vue?vue&type=style&index=0&id=7c184a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c184a3e",
  null
  
)

export default component.exports